// Wartungsarten der Fahrzeug-Wartungshistorie.
//
// Die vier fristgebundenen Arten führen ein Fälligkeitsdatum am Fahrzeug
// (`Vehicles.maintenanceDue.<key>`, ISO-String). Aus ihm entstehen die Chips in
// der Fahrzeugliste und die tägliche Erinnerung der CF `checkVehicleDeadlines`
// (dort sind Schlüssel und Kurzbezeichnungen gespiegelt — synchron halten).
// `defaultIntervalMonths` füllt beim Eintragen die nächste Fälligkeit vor und
// bleibt änderbar; ohne Wert wird nichts vorgeschlagen.

export const MAINTENANCE_TYPES = [
  { key: 'tuv', label: 'TÜV (Hauptuntersuchung)', short: 'TÜV', tracksDue: true, defaultIntervalMonths: 12 },
  { key: 'inspektion', label: 'Inspektion', short: 'Inspektion', tracksDue: true, defaultIntervalMonths: 12 },
  { key: 'eichung', label: 'Eichung Taxameter / Wegstreckenzähler', short: 'Eichung', tracksDue: true, defaultIntervalMonths: 12 },
  { key: 'oelwechsel', label: 'Ölwechsel', short: 'Ölwechsel', tracksDue: true, defaultIntervalMonths: null },
  { key: 'sonstiges', label: 'Sonstiges', short: 'Sonstiges', tracksDue: false, defaultIntervalMonths: null }
];

export const DUE_MAINTENANCE_TYPES = MAINTENANCE_TYPES.filter(type => type.tracksDue);

export const getMaintenanceType = (key) => MAINTENANCE_TYPES.find(type => type.key === key) || null;

export const getMaintenanceLabel = (record) => {
  const type = getMaintenanceType(record?.type);
  if (!type) return record?.description || 'Wartung';
  if (type.key === 'sonstiges') return record.description || type.label;
  return type.label;
};
